var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoListingsYet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 122,
    viewBox: "0 0 87 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.97 43.94L50.07 39.96L22.5 24.04L2.5 12.5V83.68L64.54 119.5V48.31L56.97 43.94ZM50.75 79.9L44.76 76.44L36.97 71.94V87.76L30.07 83.78V67.96L22.5 63.59L16.29 60V52.09L22.5 55.68L23.63 56.33L30.07 60.05V44.23L36.29 47.82L36.97 48.21V64.03L37.42 64.29L44.31 68.27L50.07 71.6L50.75 71.99V79.9Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.42 64.2901L30.07 67.9601L22.5 63.5901L16.29 60.0001V52.0901L22.5 55.6801L23.63 56.3301L30.07 60.0501L36.97 56.6001V64.0301L37.42 64.2901Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 71.99V79.9L44.76 76.44L36.97 71.94L44.31 68.27L50.07 71.6L50.75 71.99Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.97 80.3301V87.7601L30.07 83.7801L35.39 81.1201L36.97 80.3301Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.31 68.27L36.97 71.94V80.33L35.39 81.12L30.07 83.78V67.96L37.42 64.29L44.31 68.27Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.97 48.21V56.6L30.07 60.05V44.23L36.29 47.82L36.97 48.21Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.54 38.3101V109.5L64.54 119.5V48.3101L84.54 38.3101Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.54 38.31L64.54 48.31L56.97 43.94L50.07 39.96L22.5 24.04L2.5 12.5L22.5 2.5L84.54 38.31Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoListingsYet);
export default __webpack_public_path__ + "static/media/no-listings-yet.bb82cdd426c216024480288523da7f87.svg";
export { ForwardRef as ReactComponent };